import * as type from '../actionType'

interface AuthState {
  isLoggedIn: boolean
  token: string | null
}

const initialState: AuthState = {
  isLoggedIn: false,
  token: null,
}

const AuthReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.LOGIN_PROCESS_STARTED:
    case type.LOGIN_PROCESS_FINISHED:
      return {
        ...state,
        ...action.payload,
      }
    case type.UPDATE_TOKEN:
      return {
        ...state,
        token: action.payload,
      }
    case type.LOGIN_PROCESS_COMPLETED:
      return {
        ...state,
        ...action.payload,
      }
    case type.LOGIN_PROCESS_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      }
    default:
      return state
  }
}

export default AuthReducer
